import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { StyledOverlay } from '../styles/styles'
import LiveModal from 'live/components/ui/Modal'
import ButtonWithLoading from 'live/components/forms/ui/button-with-loading'
import { HotTable } from '@handsontable/react'
import { HotContainer } from '../commom'
import { Container, FormConfig, StyledLiveModal, ContentBody } from '../styles/styles'
import i18n from 'live/services/i18n'
import FormGroup from 'live/components/forms/ui/form-group'
import DateService from 'live/services/date'
import { getElementForCell } from '../functions/functions'

type DrillDownTableProps = {
    tableData: Record<string, any>
    modalTitle: string
    showModal: boolean
    setShowModal: Function
}

export const DrillDownTable = (props: DrillDownTableProps) => {
    const refTable = React.useRef<HotTable>(null)
    const [sumValue, setSumValue] = useState<number>(
        props.tableData && props.tableData['actual_hours'] ? props.tableData['actual_hours'] : 0
    )
    const drillDownData =
        props.tableData && props.tableData['actual_hours_data'] ? JSON.parse(props.tableData['actual_hours_data']) : {}

    const renderNumber = (source: string) => {
        const isNumeric = str => {
            const v = source.toString().replace('.', '').trim()
            return !isNaN(str)
        }

        if (!isNumeric(source)) return 'N/A'

        return _.round(parseFloat(source.toString().trim()), 2).toString()
    }

    const renderTimeStamp = (source: string) => {
        if (!_.isNumber(source)) return 'N/A'

        const timestamp = parseInt(source)
        return DateService.getMoment(timestamp).format('YYYY-MM-DD HH:mm:ss Z')
    }

    const generateRenderCode = (value: string, row, col, td, isReadOnly: boolean) => {
        if (value !== undefined && value !== '') {
            let container = getElementForCell(row, col)
            ReactDOM.render(<div>{value}</div>, container)
            while (td.firstChild) {
                td.removeChild(td.firstChild)
            }
            td.appendChild(container)
            if (isReadOnly) $(td).addClass('is-readOnly')
            return td
        } else {
            td.innerHTML = '<div></div>'
            if (isReadOnly) $(td).addClass('is-readOnly')
            return td
        }
    }

    return (
        <div>
            <StyledLiveModal className="modal-lg" onHide={props.showModal} show={true}>
                <LiveModal.Header>
                    <LiveModal.Title>
                        {props.modalTitle ? props.modalTitle : i18n('Drill Down Datatable')}
                    </LiveModal.Title>
                </LiveModal.Header>
                <LiveModal.Body>
                    <FormConfig>
                        <ContentBody>
                            <React.Fragment>
                                <Container>
                                    <section>
                                        <header>{i18n('High Level Data')}</header>
                                        <div className="form-group">
                                            <div style={{ display: 'flex' }}>
                                                <div style={{ width: '20%', marginRight: '5px' }}>
                                                    <FormGroup
                                                        label={'Section Size'}
                                                        type={'text'}
                                                        name={'section'}
                                                        placeholder={'Section Size'}
                                                        value={props.tableData ? props.tableData['section'] : undefined}
                                                        onChange={undefined}
                                                        readOnly={true}
                                                    />
                                                </div>
                                                <div style={{ width: '80%' }}>
                                                    <FormGroup
                                                        label={'Sub Activity'}
                                                        type={'text'}
                                                        name={'subactivity'}
                                                        placeholder={'Sub Activity'}
                                                        value={
                                                            props.tableData ? props.tableData['subactivity'] : undefined
                                                        }
                                                        onChange={undefined}
                                                        readOnly={true}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex' }}>
                                                <div style={{ width: '50%', marginRight: '5px' }}>
                                                    <FormGroup
                                                        label={'Plan Hour(s) & Day(s)'}
                                                        type={'text'}
                                                        name={'plan_hours'}
                                                        placeholder={'Plan Hour(s) & Day(s)'}
                                                        value={
                                                            props.tableData
                                                                ? renderNumber(props.tableData['plan_hours']) +
                                                                  ' / ' +
                                                                  _.round(
                                                                      parseFloat(props.tableData['plan_hours']) / 24,
                                                                      2
                                                                  )
                                                                : undefined
                                                        }
                                                        onChange={undefined}
                                                        readOnly={true}
                                                    />
                                                </div>

                                                <div style={{ width: '50%', marginRight: '5px' }}>
                                                    <FormGroup
                                                        label={'Actual Hour(s) / Day(s)'}
                                                        type={'text'}
                                                        name={'actual_hours'}
                                                        placeholder={'Actual Hour(s) / Day(s)'}
                                                        value={
                                                            props.tableData
                                                                ? renderNumber(props.tableData['actual_hours']) +
                                                                  ' / ' +
                                                                  _.round(
                                                                      parseFloat(props.tableData['actual_hours']) / 24,
                                                                      2
                                                                  )
                                                                : undefined
                                                        }
                                                        onChange={undefined}
                                                        readOnly={true}
                                                    />
                                                </div>

                                                <div style={{ width: '50%' }}>
                                                    <FormGroup
                                                        label={'Ahead-Behind Hours(s) / Day(s)'}
                                                        type={'text'}
                                                        name={'plan_hours'}
                                                        placeholder={'Plan Hours'}
                                                        value={
                                                            props.tableData
                                                                ? _.round(
                                                                      parseFloat(props.tableData['plan_hours']) -
                                                                          parseFloat(props.tableData['actual_hours']),
                                                                      2
                                                                  ) +
                                                                  ' / ' +
                                                                  _.round(
                                                                      (parseFloat(props.tableData['plan_hours']) -
                                                                          parseFloat(props.tableData['actual_hours'])) /
                                                                          24,
                                                                      2
                                                                  )
                                                                : undefined
                                                        }
                                                        onChange={undefined}
                                                        readOnly={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section>
                                        <header>
                                            {i18n('Drill Down Data')}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    float: 'right',
                                                    fontStyle: 'italic',
                                                    fontSize: '13px',
                                                    fontWeight: 'normal',
                                                    color: 'rgb(55, 163, 239)'
                                                }}
                                            >
                                                {i18n(`Duration Sum : ${sumValue} hour(s)`)}
                                            </div>
                                        </header>
                                        {drillDownData && drillDownData.length > 0 ? (
                                            <StyledOverlay>
                                                <HotContainer>
                                                    <HotTable
                                                        ref={refTable}
                                                        data={drillDownData}
                                                        settings={{
                                                            rowHeaders: false,
                                                            readOnlyCellClassName: '',
                                                            autoWrapRow: true,
                                                            columns: [
                                                                {
                                                                    data: 'timestamp_from',
                                                                    readOnly: true
                                                                },
                                                                {
                                                                    data: 'timestamp_from',
                                                                    readOnly: true,
                                                                    renderer: (
                                                                        instance,
                                                                        td,
                                                                        row,
                                                                        col,
                                                                        prop,
                                                                        value,
                                                                        cellProperties
                                                                    ) => {
                                                                        const rowData = instance.getSourceDataAtRow(row)
                                                                        const timestampTo =
                                                                            rowData && rowData['timestamp_to']
                                                                                ? rowData['timestamp_to']
                                                                                : undefined

                                                                        return generateRenderCode(
                                                                            renderTimeStamp(value) +
                                                                                ' to \n' +
                                                                                renderTimeStamp(timestampTo),
                                                                            row,
                                                                            col,
                                                                            td,
                                                                            false
                                                                        )
                                                                    }
                                                                },
                                                                {
                                                                    data: 'begin_bit_depth',
                                                                    readOnly: true,
                                                                    renderer: (
                                                                        instance,
                                                                        td,
                                                                        row,
                                                                        col,
                                                                        prop,
                                                                        value,
                                                                        cellProperties
                                                                    ) => {
                                                                        return generateRenderCode(
                                                                            renderNumber(value),
                                                                            row,
                                                                            col,
                                                                            td,
                                                                            false
                                                                        )
                                                                    }
                                                                },
                                                                {
                                                                    data: 'program_name',
                                                                    readOnly: true
                                                                },
                                                                {
                                                                    data: 'activity_name',
                                                                    readOnly: true
                                                                },
                                                                {
                                                                    data: 'activityDDR',
                                                                    readOnly: true
                                                                },
                                                                {
                                                                    data: 'duration',
                                                                    readOnly: true,
                                                                    renderer: (
                                                                        instance,
                                                                        td,
                                                                        row,
                                                                        col,
                                                                        prop,
                                                                        value,
                                                                        cellProperties
                                                                    ) => {
                                                                        return generateRenderCode(
                                                                            renderNumber(value),
                                                                            row,
                                                                            col,
                                                                            td,
                                                                            false
                                                                        )
                                                                    }
                                                                }
                                                            ],
                                                            afterSelection: (
                                                                row,
                                                                column,
                                                                row2,
                                                                column2,
                                                                preventScrolling,
                                                                selectionLayerLevel
                                                            ) => {
                                                                if (column2 === 6 && column === 6 && row !== row2) {
                                                                    let cumV = 0.0
                                                                    const start = row <= row2 ? row : row2
                                                                    const end = row <= row2 ? row2 : row
                                                                    for (let i = start; i <= end; i++) {
                                                                        const v = refTable.current?.hotInstance.getDataAtCell(
                                                                            i,
                                                                            column
                                                                        )
                                                                        cumV = cumV + parseFloat(v)
                                                                    }
                                                                    setSumValue(_.round(cumV, 2))
                                                                } else {
                                                                    setSumValue(props.tableData['actual_hours'])
                                                                }
                                                            },
                                                            colHeaders: [
                                                                'Time Stamp',
                                                                'Time Range',
                                                                'Depth From',
                                                                'Program',
                                                                'Activity',
                                                                'DDR Activity',
                                                                'Duration (h)'
                                                            ],
                                                            columnSorting: {
                                                                sortEmptyCells: true,
                                                                initialConfig: {
                                                                    column: 0,
                                                                    sortOrder: 'asc'
                                                                }
                                                            },
                                                            stretchH: 'all',
                                                            autoRowSize: true,
                                                            contextMenu: true,
                                                            height: 400
                                                        }}
                                                    ></HotTable>
                                                </HotContainer>
                                            </StyledOverlay>
                                        ) : (
                                            <div>No drill down data</div>
                                        )}
                                    </section>
                                </Container>
                            </React.Fragment>
                        </ContentBody>
                    </FormConfig>
                </LiveModal.Body>
                <LiveModal.Footer>
                    <ButtonWithLoading
                        className={`btn accept btn- mr-5`}
                        buttonMessage={'Close'}
                        buttonMessageLoading={'Copying'}
                        onClick={() => {
                            props.setShowModal(false)
                        }}
                        disabled={false}
                    />
                </LiveModal.Footer>
            </StyledLiveModal>
        </div>
    )
}
